import { BroadcastDiceRollResults, FalloutDiceRollReason, FalloutPlayer } from "../Data/Response";
import styles from './DiceRollResultView.module.scss';

interface DiceRollResultsViewArgs {
    results: BroadcastDiceRollResults;
    player: FalloutPlayer;
}

const DiceRollResultsView: React.FC<DiceRollResultsViewArgs> = args => {
    var avatar = args.player.avatar;
    var username = args.player.username;

    const character = args.results.characterId ? (args.player?.crew.characters ?? []).find(c => c.id === args.results.characterId) : null;
    if (character) {
        avatar = character.avatar;
        username = character.name;
    }

    return <li className={styles.results}>
        <div>
            <img src={avatar.smallUrl} />
            <p>{username}: {getDiceRollReason(args.results.reason)}</p>
        </div>
        <ul className={styles.standard}>
            {args.results.standardDiceResults.map(r => {
                return <li className={r.success ? styles.success : ""}>{r.roll}</li>
            })}
        </ul>
        <ul className={styles.luck}>
            {args.results.luckDiceResults.map(r => {
                return <li className={r.success ? styles.success : ""}>{r.roll}</li>
            })}
        </ul>
    </li>
}


const getDiceRollReason = (reason: FalloutDiceRollReason): string => {
    switch (reason) {
        case "attackRoll": return "Attack Roll";
        case "attackRollBonus": return "Attack Roll Bonus";
        case "confusionTest": return "Confusion Test Roll";
        case "criticalEffectIgnite": return "Critical Effect Ignite Defense Roll";
        case "criticalEffectSuppress": return "Critical Effect Suppress Defense Roll";
    }
}

export default DiceRollResultsView;